import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { of, switchMap } from 'rxjs';
import { MsalService } from '@azure/msal-angular';
import { AppAuthService } from '../app-auth.service';

export const AuthGuard: CanActivateFn | CanActivateChildFn = (route, state) =>
{
    const router: Router = inject(Router);
    const authService: MsalService = inject(MsalService);
    const appAuth: AppAuthService = inject(AppAuthService);

    // Check the authentication status
    // return inject(JwtAuthService).isLoggedInObservable().pipe(
    //     switchMap((authenticated) =>
    //     {
    //         // If the user is not authenticated...
    //         if ( !authenticated )
    //         {
    //             // Redirect to the sign-in page with a redirectUrl param
    //             const redirectURL = state.url === '/sign-out' ? '' : `redirectURL=${state.url}`;
    //             const urlTree = router.parseUrl(`sign-in?${redirectURL}`);

    //             return of(urlTree);
    //         }

    //         // Allow the access
    //         return of(true);
    //     }),
    // );

    var authenticated = authService.instance.getActiveAccount() != null;

    console.log("auth guard - authenticated", authenticated, "-", route.url.map(x => x.path).join('/'));

    if(!authenticated) {
        // Redirect to the sign-in page with a redirectUrl param
        const redirectURL = state.url === '/sign-out' ? '' : `redirectURL=${state.url}`;
        const urlTree = router.parseUrl(`sign-in?${redirectURL}`);

        return of(urlTree);
    }
    
    if(appAuth.getUser() == null)
        appAuth.getAndSetUser();
    
    // Allow the access
    return true;
    
}
